import { trackEvent } from "./src/plausible";

const shouldPreventScroll = (location) =>
    new URLSearchParams(location.search).get("prsc") === "true";

export function shouldUpdateScroll({ routerProps, getSavedScrollPosition }) {
    const { location } = routerProps;

    if (shouldPreventScroll(location)) {
        return false;
    }

    if (location.action === "POP") {
        return getSavedScrollPosition(location) || [0, 0];
    }

    return true;
}

export function onRouteUpdate({ location }) {
    if (location.hash === "#get-in-touch") {
        trackEvent("Get In Touch button clicked", {
            props: {
                "get-in-touch-button-page-title": location.pathname,
            },
        });
    }
}
